/* tslint:disable */
/* eslint-disable */
/**
 * ISO Backend Modules API
 * ISO API for the IBE.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var ApiNoteType;
(function (ApiNoteType) {
    ApiNoteType["INFO"] = "INFO";
    ApiNoteType["SPECIALREQUEST"] = "SPECIALREQUEST";
    ApiNoteType["AIRPORT"] = "AIRPORT";
    ApiNoteType["PACKAGE"] = "PACKAGE";
    ApiNoteType["RATECOMMENT"] = "RATE_COMMENT";
    ApiNoteType["MARKETINGCONSENT"] = "MARKETING_CONSENT";
    ApiNoteType["CLOSEDDATES"] = "CLOSED_DATES";
})(ApiNoteType || (ApiNoteType = {}));
function ApiNoteTypeFromJSON(json) {
    return ApiNoteTypeFromJSONTyped(json);
}
function ApiNoteTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ApiNoteTypeToJSON(value) {
    return value;
}

export { ApiNoteType, ApiNoteTypeFromJSON, ApiNoteTypeFromJSONTyped, ApiNoteTypeToJSON };
//# sourceMappingURL=ApiNoteType.js.map
